exports = module.exports = require("../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ActivityStats__LeftPane__2S9rK {\n  height: 100%;\n  /* margin-right: 10px; */\n  padding: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.ActivityStats__RightPane__iwfiV {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  padding-left: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}", ""]);

// exports
exports.locals = {
	"LeftPane": "ActivityStats__LeftPane__2S9rK",
	"RightPane": "ActivityStats__RightPane__iwfiV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskStatusPage/ActivityStats/ActivityStats.css
// module id = 873
// module chunks = 0